import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

export default function WarrantyDownloadButton({ itemId, access }: { itemId: number; access: "staff" | "customer" }) {
  const staff = trpc.warranties.getPdfDocument.useMutation();
  const customer = trpc.clarityOneRecords.getWarrantyPdfDocument.useMutation();
  const [busy, setBusy] = useState(false);
  const download = async () => {
    // Open during the click gesture so asynchronous generation is not blocked.
    const viewer = window.open("about:blank", "_blank");
    if (!viewer) {
      toast.error("Allow pop-ups to open your warranty PDF, then try again.");
      return;
    }
    viewer.opener = null;
    viewer.document.title = "Preparing warranty card";
    viewer.document.body.textContent = "Preparing your warranty card PDF…";
    setBusy(true);
    try {
      const snapshot = await (access === "staff" ? staff : customer).mutateAsync({ itemId });
      const { exportWarrantyCardPdf } = await import("@/lib/warrantyPdfExport");
      const pdf = await exportWarrantyCardPdf(snapshot);
      const url = URL.createObjectURL(pdf);
      if (!viewer.closed) viewer.location.replace(url);
      // Allow the viewer to finish loading before releasing the backing URL.
      window.setTimeout(() => URL.revokeObjectURL(url), 300_000);
    } catch {
      viewer.close();
      toast.error("Could not prepare this warranty card. Refresh the page and try again.");
    } finally {
      setBusy(false);
    }
  };
  return <button type="button" disabled={busy} onClick={download}
    className="inline-flex items-center gap-2 rounded-full bg-[#1A2744] px-4 py-2 text-xs font-semibold text-white disabled:opacity-50">
    <Download className="h-4 w-4" aria-hidden />
    {busy ? "Preparing PDF…" : "Download Warranty Card"}
  </button>;
}
